import { SimpleQueryResponse } from './../../dtos/simpleQueryResponse';
import { FilterFournDTO } from './../../dtos/filterFournDTO';
import { FournisseurModel } from './../../models/societe-linked/fournisseur.model';
import { SocieteLinkedService } from './societe-linked.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APICONSTANTS } from '../../constants/api-constants';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class FournisseurService extends SocieteLinkedService<FournisseurModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTEFOURNISSEUR, hostnameService);
  }

  getFiltredFournisseur(fitredto: FilterFournDTO): Observable<SimpleQueryResponse<FournisseurModel>> {
    return super.getAllFromObjet('GetfiltredData/', fitredto).pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  getWithCodeSociete(code: number, idSociete: number): Observable<FournisseurModel> {
    // tslint:disable-next-line
    return this.http.get<FournisseurModel>(APICONSTANTS.URLAPI.value + this.route + 'getWithCodeSociete?code=' + code + '&idSociete=' + idSociete)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }
}
